import React, { Component, Fragment } from 'react'
import { Carousel } from 'antd'

class Image extends Component {
  render() {
    const { fileLinkList } = this.props
    return (
      <Fragment>
        {fileLinkList.map((file) => (
          <a href={file} target={'_blank'}>
            <img
              style={{
                height: 'auto',
                display: 'block',
                maxWidth: '100%',
                lineHeight: '1',
              }}
              src={file}
            />
          </a>
        ))}
      </Fragment>
    )
  }
}

export default Image
